(() => {
  const choices = {
    'immersive-living-ecosystems': 'Immersive Living Ecosystems',
    'ecosystem-facility-automation': 'Ecosystem & Facility Automation',
    'research-conservation-breeding': 'Research, Conservation & Breeding',
    'sales-partners': 'Sales Partners',
    'development-integration': 'Development & Integration',
    'works-with-home-ecosystems': 'Works with Home Ecosystems'
  };
  document.querySelectorAll('[data-he-b2b-form]').forEach(shell => {
    if (shell.dataset.heB2bReady) return;
    shell.dataset.heB2bReady = 'true';
    const select = shell.querySelector('[data-he-b2b-select]');
    const status = shell.querySelector('[data-he-b2b-status]');
    const sync = () => {
      shell.querySelectorAll('[data-he-b2b-fields]').forEach(group => {
        const active = group.dataset.heB2bFields === select.value;
        group.hidden = !active;
        group.disabled = !active;
      });
      if (status) status.textContent = select.value ? `Your enquiry will include: ${choices[select.value]}.` : '';
    };
    const rememberChoice = (hash) => {
      const url = new URL(location.href);
      if (hash) url.hash = hash;
      if (select.value) url.searchParams.set('area', select.value);
      else url.searchParams.delete('area');
      history.replaceState(history.state, '', url);
      sync();
    };
    select.addEventListener('change', () => rememberChoice());
    // Validation errors and browser back navigation keep the visitor's selection.
    const requested = new URLSearchParams(location.search).get('area');
    if (!select.value && choices[requested] && [...select.options].some(o => o.value === requested)) select.value = requested;
    sync();
    window.addEventListener('pageshow', sync);
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-he-b2b-choice]');
      if (!link || link.hash !== `#${shell.id}` || ![...select.options].some(o => o.value === link.dataset.heB2bChoice)) return;
      event.preventDefault();
      select.value = link.dataset.heB2bChoice;
      rememberChoice(link.hash);
      shell.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      requestAnimationFrame(() => select.focus({preventScroll: true}));
    });
  });
})();
